import {FC, useMemo} from 'react';
import {Col, Row} from 'react-bootstrap';
import {Formik, Form} from 'formik';
import * as Yup from 'yup';
import {FormPageFooter} from "@components/falcon/common/forms";
import {RefBaseInfoBlock} from "./forms";
import {RefFormValues, TargetType} from "@components/consumer/refs/forms/refBaseInfoBlock";

export interface RefFormProps {
    initialValues: RefFormValues;
    onSubmit: (values: RefFormValues) => Promise<any>;
    onDelete?: () => any;
    editForm?: boolean;
    cancelUrl: string;
}

const RefForm: FC<RefFormProps> = ({
    initialValues,
    onSubmit,
    onDelete,
    editForm,
    cancelUrl
}) => {

    const validationSchema = useMemo(() => Yup.object<RefFormValues>({
        name: Yup.string()
            .max(256)
            .required(),
        description: Yup.string()
            .max(10000),
        isActive: Yup.boolean()
            .required(),
        hidden: Yup.boolean()
            .required(),
        order: Yup.number()
            .required(),
        targetType: Yup.mixed<TargetType>()
            .oneOf(Object.values(TargetType))
            .required()
    }), []);

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            enableReinitialize
        >
            <Form>
                <Row className="g-3">
                    <Col xs={12}>
                        <RefBaseInfoBlock editForm={editForm} />
                    </Col>
                    <Col>
                        <FormPageFooter
                            cancelUrl={cancelUrl}
                            onDelete={onDelete} />
                    </Col>
                </Row>
            </Form>
        </Formik>
    );
};

export default RefForm;
